import { render, staticRenderFns } from "./donor-home.vue?vue&type=template&id=c063f08a&"
import script from "./donor-home.vue?vue&type=script&lang=js&"
export * from "./donor-home.vue?vue&type=script&lang=js&"
import style0 from "./donor-home.vue?vue&type=style&index=0&id=c063f08a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports